export interface DigestSection {
  section: string;
  text: string;
  id: string;
}

export type DigestReasoningType = "standard" | "advanced";

export interface DigestFormStateType {
  sections: DigestSection[];
  cronExpression: string;
  selectedSlackChannels: Array<{ id: string; name: string; isMember: boolean }>;
  selectedDiscordWebhooks: Array<{ id: string; name: string }>;
  notificationFormat: "summary" | "full";
  reasoning: DigestReasoningType;
  name: string;
}

export const createInitialDigestFormState = (): DigestFormStateType => ({
  sections: [{ section: "", text: "", id: "1" }],
  cronExpression: "0 9 * * *",
  selectedSlackChannels: [],
  selectedDiscordWebhooks: [],
  notificationFormat: "summary",
  reasoning: "advanced",
  name: "",
});

export const mapToDigestSections = (sections: Array<{ section: string; text: string }>): DigestSection[] =>
  sections.map((s, index) => ({ section: s.section, text: s.text, id: (index + 1).toString() }));
